import React from 'react';
import { Link } from 'react-router-dom';

class ZeventLogo extends React.Component {
	render () {
		return (
			<Link to="/2018">
				<img src={"/static/images/ZEvent-logo-" + this.props.match.params.year + ".png"} 
					className="zeventLogo m-auto block mtm" />
			</Link>
		);
	}
}

export default ZeventLogo;